<template>
  <div class="step-config-summary" data-testid="step-config-summary__view">
    <div class="step-config-summary__section">
      <div class="step-config-summary__subtitle">Configuration Summary:</div>

      <div class="step-config-summary__section-title">Basic Details</div>
      <div class="step-config-summary__section">
        <div class="step-config-summary__detail">
          File Name : <span>{{ nameFile }}</span>
        </div>
        <div class="step-config-summary__detail">
          Ignore Rows : <span>{{ ignoreRow }}</span>
        </div>
        <div class="step-config-summary__detail">
          Ignore Columns : <span>{{ ignoreColums }}</span>
        </div>
      </div>

      <div class="step-config-summary__section-title">Column Mapping</div>
      <div class="d-flex">
        <div>
          <div
            v-for="(fileCol, i) in fileColums"
            :key="i"
            class="step-config-summary__mapping-item"
          >
            <div class="step-config-summary__mapping-pair" v-if="(twoDiArray[i] || [])[1]">
              <v-chip label class="d-block flex-grow-1" outlined color="primary">
                <span>{{ fileCol.name }}</span>
              </v-chip>
              <div class="step-config-summary__divider-bridge">
                <v-divider></v-divider>
              </div>
              <div
                :class="[
                  'step-config-summary__drop-zone',
                  { 'step-config-summary__drop-zone--filled': (twoDiArray[i] || [])[1] },
                ]"
              >
                <div class="step-config-summary__drop-content">
                  <span v-html="(twoDiArray[i] || [])[1] || '&nbsp;'"></span>
                  <v-spacer></v-spacer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="step-config-summary__section-title mt-4">User Column Mapping</div>
      <div class="d-flex">
        <div>
          <div class="d-flex">
            <div>
              <div
                v-for="(fileCol, i) in userMappedColumns"
                :key="i"
                class="step-config-summary__mapping-item"
              >
                <div class="step-config-summary__mapping-pair">
                  <v-chip label class="d-block flex-grow-1" outlined color="primary">
                    <span>{{ fileCol[1] }}</span>
                  </v-chip>
                  <div class="step-config-summary__divider-bridge">
                    <v-divider></v-divider>
                  </div>
                  <div class="step-config-summary__drop-zone step-config-summary__drop-zone--filled">
                    <div class="step-config-summary__drop-content">
                      <span v-html="fileCol[0] || '&nbsp;'"></span>
                      <v-spacer></v-spacer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="step-config-summary__chips-section">
        <div class="step-config-summary__section-title">Removed Columns</div>
        <v-chip
          v-for="(colum, i) in selectColums"
          :key="'B' + i"
          class="ma-1"
          label
          text-color="primary"
          color="blue-grey lighten-5"
        >
          <span>{{ colum }}</span>
        </v-chip>
      </div>

      <div v-if="unMapedColumc.length > 0" class="step-config-summary__chips-section">
        <div class="step-config-summary__section-title">Create Columns</div>
        <v-chip
          v-for="(colum, i) in unMapedColumc"
          :key="'C' + i"
          class="ma-1"
          label
          text-color="primary"
          color="blue-grey lighten-5"
        >
          <span>{{ colum }}</span>
        </v-chip>
      </div>

      <div v-else class="step-config-summary__chips-section">
        <div class="step-config-summary__section-title" v-if="ignoredColumns.length > 0">
          Ignored Columns
        </div>
        <v-chip
          v-for="(colum, i) in ignoredColumns"
          :key="'D' + i"
          class="ma-1"
          label
          text-color="primary"
          color="blue-grey lighten-5"
        >
          <span>{{ colum }}</span>
        </v-chip>
      </div>
    </div>

    <div class="step-config-summary__actions">
      <v-btn color="primary" @click="onBack" data-testid="step-config-summary__back-btn">
        <p>Back</p>
      </v-btn>
      <v-btn color="primary" @click="onFinish" data-testid="step-config-summary__finish-btn">
        <p>Finish</p>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepConfigSummary',
  props: {
    nameFile: {
      type: String,
      default: '',
    },
    ignoreRow: {
      type: Number,
      default: 0,
    },
    ignoreColums: {
      type: Number,
      default: 0,
    },
    fileColums: {
      type: Array,
      required: true,
      default: () => [],
    },
    twoDiArray: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectColums: {
      type: Array,
      required: true,
      default: () => [],
    },
    unMapedColumc: {
      type: Array,
      required: true,
      default: () => [],
    },
    ignoredColumns: {
      type: Array,
      required: true,
      default: () => [],
    },
    userMappedColumns: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    onBack() {
      this.$emit('back');
    },
    onFinish() {
      this.$emit('finish');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './StepConfigSummary.scss';
</style>
